<div class="sorting-toggle">
  <label for="sortingToggle" i18n="@@SortingTitle" id="sortingLabel" class="sorting-toggle__label"
    >Sort by:</label
  >
  <mat-select
    name="sorting-toggle"
    aria-describedby="sortinghint"
    id="sortingToggle"
    aria-label="Sort by:"
    (selectionChange)="select($event.value)"
    panelClass="sort-select"
    appSelect
    [noIcon]="true"
    [placeholder]="placeholderText | translate"
    [(value)]="selected"
    [hideSingleSelectionIndicator]="true"
  >
    @for (type of sortTypes; track type) {
      <mat-option
        [value]="type.title"
        id="sort_option_{{ type.title | removeSpaces }}"
        class="sort-options"
      >
        <span>{{ type.title | translate }}</span>
        @if (type.icon && type.icon !== 'ico-gbp') {
          <i class="{{ type.icon }}"></i>
        }
        @if (type?.icon === 'ico-gbp') {
          <img
            [ngStyle]="themeService.isScionEnv ? { filter: 'invert(1)' } : {}"
            alt=""
            src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/filter-coin-icon.svg"
            class="coin-svg"
          />
        }
      </mat-option>
    }
  </mat-select>
  <span hidden id="sortinghint">Used to sort results</span>
</div>
